import { CompanySubscription, CreditSubscription, DesignerSubscription } from '../types/Subscription';

export type SubscriptionConfig = {
    title: string;
    subtitle: string;
    score: number;
    features: {
        id?: string;
        title: string;
        description?: string;
        previewImage?: string;
        highlight?: boolean;
        notIncluded?: boolean;
        marginTop?: number;
    }[];
};

export const CompanySubscriptionConfig: Record<CompanySubscription, SubscriptionConfig> = {
    [CompanySubscription.NONE]: {
        title: 'Basic',
        subtitle: 'Get Started',
        score: 0,
        features: [
            {
                id: 'basicCompanyProfileItem',
                title: 'Company listing, services, team members, contact information',
                description: 'Your profile is included in search results',
                notIncluded: true,
            },
            {
                id: 'basicProductsListedItem',
                title: 'Unlimited product listings',
                description: 'Your company’s products and service listings',
                notIncluded: true,
            },
            {
                id: 'basicReferenceContentItem',
                title: 'Author 1 reference designs',
                description: 'Showcase your products in real-world applications via content rich single line diagrams',
                notIncluded: true,
            },
            {
                id: 'basicLeadGenerationItem',
                title: 'RE+ event booth number and your own QR code',
                description: 'See your booth scan counts and event summary',
                notIncluded: true,
            },
            {
                id: 'basicFreeLeadsItem',
                title: 'Your first 5 leads for free',
                description:
                    'See who is behind your first 5 QR scans or messages and chat with them. Upgrade to Premium for more',
                notIncluded: true,
            },
        ],
    },
    [CompanySubscription.PREMIUM]: {
        title: 'Premium',
        subtitle: 'Get Leads',
        score: 2,
        features: [
            {
                id: 'premiumCompanyProfileItem',
                title: 'Profile includes Premium Badge',
                description: 'Boosted placement in search results',
                highlight: true,
            },
            {
                id: 'premiumProductsListedItem',
                title: 'Boosted product placement in search results',
                description: 'Your products and case studies rank higher than Basic listings',
                highlight: true,
            },
            {
                id: 'premiumReferenceContentItem',
                title: 'Author 3 reference designs',
                description: 'Showcase more of your products in real-world applications',
                highlight: true,
            },
            {
                id: 'premiumLeadGenerationItem',
                title: 'Capture engaged leads from your QR code',
                description: 'Visitors who scan you at an RE+ event land in your Showtime Leads dashboard',
                highlight: true,
            },
            {
                id: 'premiumAnalyticsInsightsItem',
                title: 'Unlimited leads: see who scanned or messaged you',
                description:
                    'Unlock the name, company, job title and interests behind every scan and message, and chat with them directly',
                highlight: true,
            },
        ],
    },
};

export const DesignerSubscriptionConfig: Record<DesignerSubscription, SubscriptionConfig> = {
    [DesignerSubscription.NONE]: {
        title: 'Free',
        subtitle: 'Try it for free with limited access',
        score: 1,
        features: [
            {
                title: 'Up to 3 designs, 1 credit / component',
            },
            {
                title: 'Real-time collaboration',
            },
            {
                title: 'Product catalog & reference templates',
            },
            {
                title: 'Share, comment & mention',
            },
            {
                title: '100 credits to try simulations & expert support',
            },
        ],
    },
    [DesignerSubscription.STANDARD]: {
        title: 'Plus',
        subtitle: 'Full platform access for your team',
        score: 2,
        features: [
            {
                title: 'Unlimited designs & components',
            },
            {
                title: 'Shared team product library',
            },
            {
                title: 'Link products to designs',
            },
            {
                title: 'Priority support',
            },
            {
                id: 'buy-credits',
                title: 'Buy credits for simulations & expert support',
            },
        ],
    },
};

export const CreditSubscriptionConfig: Record<CreditSubscription, SubscriptionConfig> = {
    [CreditSubscription.STANDARD]: {
        title: 'Credit',
        subtitle: '',
        score: 10,
        features: [],
    },
    [CreditSubscription.NONE]: {
        title: 'No Credit',
        subtitle: '',
        score: 0,
        features: [],
    },
};
